<template lang="pug">
    #employee-list
        model-data-table(
            no-data-text='Sin empleados.'
            ref='table'
            remind-key='employee-list'
            param-search='names' 
            v-bind='tableProps'
            @detail='submitUpdate'
            @remove='submitDelete( $event.item.id )'
        )
            template( slot='actions' slot-scope='props' )
                v-btn-action( 
                    color="success"
                    tooltip="Activar contrato"
                    :disabled='!props.item.can_active_contract'
                    @click="showContractInformation( props.item )" 
                )
                    v-icon check_circle
        //crud-create-button(
            v-bind="createButtonProps"
            v-if="$can('CREATE_EMPLOYEE')"
            )
        //crud-data-table( 
            v-bind="dataTableProps" 
            @delete="submitDelete" 
            @show="submitShow"
            :showButton="() => $can('VIEW_DETAIL_EMPLOYEE')"
            :deleteButton="() => $can('DELETE_EMPLOYEE')"
            )
            v-btn( 
                v-if="!props.item.active_contract" 
                @click="showContractInformation( props.item )" 
                color="success" 
                flat 
                icon 
                slot="actions" 
                slot-scope="props"  
                )
                v-icon check
        v-dialog( fullscreen v-model='dialogContract' )
            v-toolbar( color="grey darken-4" dark sticky flat )
                v-toolbar-title Estado empleado: Contrato Inactivo
                v-spacer
                v-btn( icon dark @click="toggleOpen")
                    v-icon close
            employee-contracts(
                :arrContractsProp="allContracts" 
                ref="invalidContractsForm" 
                @closeDialogContract="closeDialog"
                )    
                
</template>

<script>
//
import { mapActions, mapState } from 'vuex'
import {
    CrudCreateButton,
    CrudDataTable,
} from '@/components/reusable_components'
import EmployeeService from '@/services/api/employee'
import PrevisionService from '@/services/api/prevision'
import { EmployeesFilters } from './filters'
import { EmployeesListHeaders } from './headers'
import EmployeeAllContracts from './EmployeeAllContracts'
/* libraries */
import moment from 'moment'
//
import { VBtnAction, ModelDataTable } from '@/components/reusable_components/next'
import EmployeeModel from '@/models/HumanResource/HrEmployee'
import EmployeeFilters from './partials/EmployeeFilters'
import EmployeeHeaders from './partials/EmployeeHeaders'
//
export default {
    components: {
        'crud-create-button': CrudCreateButton,
        'crud-data-table': CrudDataTable,
        'employee-contracts': EmployeeAllContracts,
        ModelDataTable,
        VBtnAction,
    },
    computed: {
        /**
         *
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        createButtonProps() {
            return {
                action: this.submitCreate,
            }
        },

        /**
         *
         */
        dataTableProps() {
            return {
                ...this.table,
                headers: EmployeesListHeaders,
                noAutoWidth: true,
                noSearchBox: true,
                service: EmployeeService,
            }
        },
        /**
         *
         */
        allContracts: {
            get: function() {
                return this.contractsInactive
            },
            set: function(contracts) {
                this.contractsInactive = contracts
            },
        },

        /**
         * 
         */
        tableProps() {
            return {
                filters     : EmployeeFilters,
                headers     : EmployeeHeaders,
                rowsPerPage : 25,
                service     : EmployeeModel,
            }
        }
    },
    data() {
        return {
            selected: null,
            table: {
                filters: EmployeesFilters,
            },
            dialogContract: false,
            contractsInactive: [],
        }
    },
    methods: {
        /**
         *
         */

        ...mapActions('MenuesModule', ['setTitleTopBar', 'setItemsTopBar']),

        /**
         *
         */

        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        mapPrevisionToOption(prevision) {
            return {
                text: prevision.name,
                value: prevision.id,
            }
        },

        toggleOpen: function() {
            this.dialogContract = false
        },

        /**
         *
         */
        async reset() {
            //
            this.table.filters[5].options = (await PrevisionService.fetchAll()).map(
                this.mapPrevisionToOption
            )
        },

        /**
         *
         */
        responseDelete({ error, message, status }) {
            //
            this.resetSnackbarState()

            //
            switch (status) {
                case 'success':
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Empleado eliminado.'
                    )
                    this.$refs.table.refresh()
                    break
                default:
                    this.showSnackbar(
                        'error',
                        'Error.',
                        error ? error : message
                    )
                    break
            }
        },

        /**
         *
         */
        showSnackbar(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },

        /**
         *
         */
        submitCreate() {
            this.$router.push({ name: 'employee-create' })
        },

        /**
         *
         */
        submitDelete(id) {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack('eliminar empleado')
            this.showSnackbar('warning', '¿Desea eliminar el empleado?')

            //
            this.selected = id
        },

        /**
         *
         */
        submitUpdate({ item }) {
            this.$router.push({ name: 'employee-details', params: { id: item.id } })
        },
        /**
         *
         */
        showContractInformation(item) {
            console.log(item, 'all data')
            this.allContracts = this.formatDateContract(item.all_contract, item)
            this.dialogContract = true
        },
        /**
         *
         */
        formatDateContract(contracts, employeeInfo) {
            return contracts.map(contract => {
                let newContract = { ...contract }
                newContract.created_at = moment(contract.created_at).format(
                    'DD/MM/YYYY'
                )
                newContract.updated_at = moment(contract.updated_at).format(
                    'DD-MM-YYYY'
                )
                newContract.text = `${employeeInfo.names} ${employeeInfo.last_name1} ${newContract.created_at}`
                return newContract
            })
        },
        /**
         *
         */
        showDialogValidateContract(contracts) {},
        /**
         *
         */
        closeDialog() {
            this.dialogContract = false
            this.$refs.table.refresh()
        },
    },
    beforeMount() {
        this.setTitleTopBar('Empleados')
    },
    mounted() {
        this.setItemsTopBar([
            {
                text: 'crear empleado',
                icon: 'add_circle',
                action: this.submitCreate,
            }
        ])
    },
    watch: {
        /**
         *
         */
        async responseConfirm() {
            //
            switch (this.responseConfirm) {
                case 'eliminar empleado':
                    this.responseDelete(
                        await EmployeeService.remove(this.selected)
                    )
                    break
            }
        },
        /**
         *
         */
        dialogContract(val) {
            if (val == false) {
                this.$refs.invalidContractsForm.$refs.validateContractForm.$refs.form.reset()
                this.$refs.invalidContractsForm.resetSelectorContracts()
                this.$refs.invalidContractsForm.contractStructureType = null
                this.$refs.invalidContractsForm.arrContractStructureType = []
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_EMPLOYEE')) ctx.$router.push('/')
        })
    },
}
</script>

